"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPurchaseLimitCreateInputSchema = exports.APosPurchaseLimitSchema = exports.APosPurchaseLimitPeriodSchema = exports.APosPurchaseLimitScopeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosPurchaseLimitScopeSchema = zod_1.z.enum(['product', 'category', 'product_type']);
exports.APosPurchaseLimitPeriodSchema = zod_1.z.enum(['per_transaction', 'daily', 'weekly', 'monthly']);
exports.APosPurchaseLimitSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    limitId: id_schema_1.EntityIdSchema,
    scope: exports.APosPurchaseLimitScopeSchema,
    scopeId: zod_1.z.string().min(1),
    maxQuantity: zod_1.z.number().int().positive(),
    period: exports.APosPurchaseLimitPeriodSchema,
    locationIds: zod_1.z.array(zod_1.z.string()).optional(),
    isActive: zod_1.z.boolean().default(true),
    reason: zod_1.z.string().max(500).optional(),
    regulatoryReference: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosPurchaseLimitCreateInputSchema = zod_1.z.object({
    scope: exports.APosPurchaseLimitScopeSchema,
    scopeId: zod_1.z.string().min(1),
    maxQuantity: zod_1.z.number().int().positive(),
    period: exports.APosPurchaseLimitPeriodSchema,
    locationIds: zod_1.z.array(zod_1.z.string()).optional(),
    reason: zod_1.z.string().max(500).optional(),
    regulatoryReference: zod_1.z.string().optional(),
});
//# sourceMappingURL=purchase-limit.schema.js.map